import { useSelector } from "react-redux";
import { IMainReduxState } from "core/interfaces.config";
import { IInstance } from "services/poona/poona.interfaces";

const useInstance = (): IInstance | undefined =>
  useSelector((reducers: IMainReduxState) => reducers.instance);

export default useInstance;
